interface CategoryFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryFilter({
  categories,
  activeCategory,
  onCategoryChange,
}: CategoryFilterProps) {
  return (
    <div className="mb-8">
      <div className="flex flex-wrap gap-3 justify-center">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => onCategoryChange(category)}
            className={`px-6 py-2 rounded-full font-body font-medium transition-brand ${
              activeCategory === category
                ? 'bg-primary text-primary-foreground shadow-brand'
                : 'bg-card text-foreground border border-border hover:bg-muted hover:border-primary'
            }`}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
}